<h2 mat-dialog-title>Confirmar tus datos</h2>
<mat-dialog-content class="mat-typography">
    <p>Por favor, verificá que tus datos sean correctos antes de finalizar el registro.</p>

    <div class="datos-container">
        <div class="dato">
            <span class="dato-label">Nombre</span>
            <span class="dato-valor">{{ data.nombrePersona }}</span>
        </div>
        <div class="dato">
            <span class="dato-label">Apellido</span>
            <span class="dato-valor">{{ data.apellidoPersona }}</span>
        </div>
        <div class="dato">
            <span class="dato-label">Identificación</span>
            <span class="dato-valor">{{ data.identificacion }}</span>
        </div>
        <div class="dato">
            <span class="dato-label">Teléfono (WhatsApp)</span>
            <span class="dato-valor">{{ data.telefono }}</span>
        </div>
        <div class="dato dato-email">
            <span class="dato-label">Email</span>
            <span class="dato-valor">{{ data.email }}</span>
        </div>
    </div>

    <div class="aviso">
        Verificá tu <strong>email</strong> con atención: no se volverá a validar y será tu medio de acceso al sistema.
    </div>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button mat-raised-button (click)="editar()">Editar</button>
    <button mat-raised-button color="primary" (click)="confirmar()" cdkFocusInitial>Confirmar registro</button>
</mat-dialog-actions>
